import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a3ab9abf711180014cf84af_1782298668455_78c81002/proposallink/src/app/vendor-management/page.tsx");
